const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/com/eCheckin/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        startTitle: 'Bequem online anmelden: So funktioniert der Online Check-in',
        startContent:
            '<ul>    <li>Geben Sie Ihren persönlichen Daten und Versicherungsinformationen an.</li>    <li>Machen Sie Angaben zu Ihrem Umfeld.</li>    <li>Erlauben Sie uns, Informationen von anderen Ärztinnen und Ärzten einzuholen.</li>    <li>Erhalten und Lesen Sie allgemeine Informationen zu Ihrem Fall.</li></ul>',
        finalizeTitle: 'Allen Informationen erfolgreich erfasst. Sie können den Check-in nun abschliessen.',
        finalizeContent:
            'Falls Sie Ihre Angaben nochmals kontrollieren möchten, können Sie dies nun Drücken auf <strong>Zurück</strong> tun. Sobald Sie den Check-in abschliessen, können Sie Ihre Angaben nicht mehr anpassen.',
        arbeitgeber: 'Arbeitgeber',
        employment: 'Ich bin',
        company: 'Firma',
        streetAndNumber: 'Strasse und Nr.',
        country: 'Land',
        tel: 'Telefon',
        employed: 'Angestellt',
        unemployedRAV: 'Stellenlos RAV',
        notEmployed: 'Nicht berufstätig',
        selfEmployed: 'Selbständig',
        einholenInfo: 'Einholen von Informationen',
        einholenInfo1:
            'Das Demospital Züri-West möchte bei den vorbehandelnden Ärztinnen und Ärzten medizinische Informationen einholen können.',
        einholenInfo2:
            'Sind Sie damit einverstanden und entbinden Sie die vorbehandelnden Ärzte von ihrer Schweigepflicht?',
        einwArzt: 'Hausarzt / Hausärztin',
        keinHausarzt: 'Ich habe keinen Hausarzt / Hausärztin',
        bezEhepartner: 'Ehepartner',
        bezElternteil: 'Elternteil',
        bezGeschwister: 'Geschwister',
        bezLebenspartner: 'Lebenspartner',
        kontakt: 'Kontaktperson / Angehörige',
        keineAngaben: 'Ich möchte keine Angaben zu Angehörigen machen',
        beziehung: 'Beziehung',
        patInfo: 'Patienteninformationen',
        studienTeilnahmeQuestion: 'Dürfen wir Sie bezüglich Studienteilnahmen kontaktieren?',
        pleaseReadAndConfirm:
            'Bitte lesen Sie folgende Informationen. Sie müssen bestätigen, dass Sie diese gelesen haben.',
        verhaltenLakaroskop: 'Verhalten nach laparoskopischer Blinddarm-Operation',
        aufklaerPeg: 'Aufklärung PEG-Sonde',
        USZlink: 'Klinische Studien am USZ',
        checkliste: 'Checkliste bei Spitaleintritt',
        persAngaben: 'Persönliche Angaben',
        male: 'Männlich',
        female: 'Weiblich',
        ledig: 'Ledig',
        verheiratet: 'Verheiratet',
        geschieden: 'Geschieden',
        dateOfBirth: 'Geburtstag',
        gender: 'Geschlecht',
        zivilstand: 'Zivilstand',
        language: 'Sprache',
        nationality: 'Nationalität',
        profession: 'Beruf',
        religion: 'Religion',
        ahv: 'AHV-Nr.',
        ahvHelpText: 'Geben Sie Ihre 13-stellige AHV-Nummer in dieses Feld ein.',
        versicherungLabel: 'Ver­sicherung',
        illness: 'Krankheit',
        accident: 'Unfall',
        medicalInsurance: 'Kranken­versicherung',
        accidentInsurance: 'Unfallversicherung',
        klasseAllg: 'Allgemein',
        klasseHalbprivat: 'Halbprivat',
        klassePrivat: 'Privat',
        versicherungName: 'Name der Versicherung',
        zusatzVersicherung: 'Zusatzversicherung',
        behandlungsgrund: 'Behandlungs­grund',
        studienTeilnahme: 'Studienteilnahme',
        kostenuebernahme: 'Kostenübernahme und Einverständnis',
        kostenuebernahmeText:
            'Der Patient/die Patientin nimmt zur Kenntnis, dass er/sie grundsätzlich gegenüber dem Demospital Schuldner ist. Sollte keine vollumfängliche Kostengutsprache und/oder Kostenübernahme eines Leistungsträgers (Versicherung/Kanton) vorliegen, werden die Kosten dem Patienten/der Patientin in Rechnung gestellt. Das Demospital kann mangels Kostensicherung den Patienten/die Patientin auffordern, ein Depot über die voraussichtlichen Behandlungskosten zu hinterlegen.<br><br>Der Patient/die Patientin ermächtigt das Demospital der Krankenversicherung und/oder anderen Kostenträgern die für die Beurteilung der Leistungspflicht notwendigen medizinischen Angaben bekannt zu geben. Die Weitergabe der Daten erfolgt unter Berücksichtigung der Auflagen des Datenschutzgesetzes.',
        datenweitergabeText:
            'Der Patient/die Patientin ist einverstanden, dass das Demospital medizinische Daten elektronisch oder in Papierform an nachbehandelnde Ärzte und Institutionen (Spitäler, Rehakliniken) weitergibt (bitte ankreuzen).',
        datenschutzerklärungText: 'Ich habe die {link} gelesen und stimme dieser zu.',
        datenschutzerklärungLink: 'Datenschutzerklärung',
        zustVersicherung: 'Kostenträger',
        versichertenNr: 'Policen-/Kunden-Nr.',
        versichertenKartenNr: 'Versicherungskarten-Nr.',
        klasse: 'Versicherungsklasse',
    },
    __RELATIVE_SOURCE_FILE__
);
